
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {TakipEntity} from "@/entity/TakipEntity";
import {TakipTalebiEntity} from "@/entity/TakipTalebiEntity";
import {AlacakEntity} from "@/entity/AlacakBelgeler/AlacakEntity";
import AlacakKalemiEntity from "@/entity/AlacakBelgeler/AlacakKalemiEntity";
import FormWrapper from "@/components/FormWrapper.vue";
import {AlacakKalemiAlani} from "@/enum/AlacakKalemiAlani";

@Component({
  components: {FormWrapper},
})
export default class KapakHesabiAlacakKalemleriInfo extends Vue {
  @Prop() item!: TakipEntity;
  @Prop() alacakKalemAlaniId!: number | number[];

  AlacakKalemiAlani = AlacakKalemiAlani;
  alacakKalemleri: Array<AlacakKalemiEntity> = [];

  mounted() {
    this.load();
  }

  @Watch('item')
  onItemChange() {
    this.load();
  }

  load() {
    this.getir();
  }

  getir() {
    this.alacakKalemleri = [];
    const ids = Array.isArray(this.alacakKalemAlaniId) ? this.alacakKalemAlaniId : [this.alacakKalemAlaniId];

    this.item.talepler.forEach((takipTalebi: TakipTalebiEntity) => {
      takipTalebi.alacaklar.forEach((alacak: AlacakEntity) => {
        alacak.alacak_kalemleri.forEach((alacakKalemi: AlacakKalemiEntity) => {
          if (ids.includes(alacakKalemi.alacak_kalemi_alani.id)) {
            this.alacakKalemleri.push(alacakKalemi);
          }
        })
      })
    })
  }

  isKismiOdeme(alacakKalemi: AlacakKalemiEntity): boolean {
    if (alacakKalemi.alacak_kalemi_alani.id !== AlacakKalemiAlani.eklenenNafaka) return false;
    const nafakaTutar = Number(alacakKalemi.talep_edilen_nafaka_tutari || alacakKalemi.tutar);
    const tahsilEdilmeyen = Number(alacakKalemi.tahsil_edilmeyen_tutar ?? nafakaTutar);
    return tahsilEdilmeyen > 0 && tahsilEdilmeyen < nafakaTutar;
  }

  getNafakaRowClass(alacakKalemi: AlacakKalemiEntity): string {
    if (this.isKismiOdeme(alacakKalemi)) {
      return 'kismi-odeme-row';
    }
    if (alacakKalemi.alacak_kalemi_alani.takip_oncesi_mi) {
      return 'birikmis-nafaka-row';
    }
    return '';
  }

  print() {
    this.$helper.printComponent('alacakKalemleri'+this.alacakKalemAlaniId);
  }
}
